/** `https://example.com/a` → `example.com/a`: what a website input holds. */
export function stripProtocol(url: string | null | undefined): string {
  return (url ?? '').trim().replace(/^https?:\/\//i, '');
}

/** A bare website as the URL the API takes. Blank stays blank. */
export function ensureHttps(url: string | null | undefined): string {
  const trimmed = (url ?? '').trim();
  if (!trimmed) return trimmed;
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

/** A bare domain passes; so does a full http(s) URL. Any other scheme fails on the hostname. */
export function isValidWebsite(value: string): boolean {
  try {
    const { hostname } = new URL(ensureHttps(value));
    return hostname.includes('.') && !hostname.startsWith('.') && !hostname.endsWith('.');
  } catch {
    return false;
  }
}

/**
 * A website made safe for an `href`, or null. A bare host would otherwise resolve
 * relative to the admin; `javascript:` and other schemes are refused.
 */
export function websiteHref(website: string | null | undefined): string | null {
  const trimmed = website?.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return null;
  return `https://${trimmed}`;
}
